function slugify(value = "") {
  return String(value)
    .trim()
    .replace(/([a-z0-9])([A-Z])/g, "$1-$2")
    .replace(/[_\s]+/g, "-")
    .replace(/[^a-zA-Z0-9-]/g, "")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "")
    .toLowerCase();
}

export function buildPath(controllerName, actionName) {
  // If actionName is already a full path, use it as is.
  if (actionName && actionName.startsWith("/")) {
    return actionName;
  }

  const controllerSlug = slugify(controllerName);
  const actionSlug = slugify(actionName);

  if (!controllerSlug && !actionSlug) return null;

  // Treat index/list/read actions as module root route.
  if (!actionSlug || ["index", "list", "read", "view"].includes(actionSlug)) {
    return `/${controllerSlug || actionSlug}`;
  }

  if (["edit", "update"].includes(actionSlug)) {
    return controllerSlug ? `/${controllerSlug}/:id/edit` : `/:id/edit`;
  }

  if (actionSlug === "new" || actionSlug === "create") {
    return controllerSlug ? `/${controllerSlug}/new` : `/new`;
  }

  return controllerSlug ? `/${controllerSlug}/${actionSlug}` : `/${actionSlug}`;
}

export function hasPermission(menu, actionType = "read") {
  const actionKeyMap = {
    create: "isCreate",
    read: "isRead",
    update: "isUpdate",
    delete: "isDelete",
  };

  const key = actionKeyMap[String(actionType).toLowerCase()] || actionType;
  return Boolean(menu?.permissions?.[key]);
}

export function sortMenus(menuItems = []) {
  const seen = new Set();
  return [...menuItems]
    .filter((item) => {
      if (!item?.menuName) return true;
      if (seen.has(item.menuName)) return false;
      seen.add(item.menuName);
      return true;
    })
    .sort((a, b) => (a?.displayOrder || 0) - (b?.displayOrder || 0))
    .map((menu) => ({
      ...menu,
      children: sortMenus(Array.isArray(menu?.children) ? menu.children : []),
    }));
}

export function generateRoutesFromMenu(menuData = [], resolveComponent) {
  const buildNode = (menu) => {
    const path = buildPath(menu?.controllerName, menu?.actionName);
    const children = (menu?.children || [])
      .flatMap((child) => buildNode(child))
      .filter(Boolean);
    const component = resolveComponent(menu);

    if (!path || !component) {
      return children;
    }

    return {
      id: menu?.id || `${menu?.controllerName}-${menu?.actionName}`,
      path,
      component,
      menu,
      children,
    };
  };

  return sortMenus(menuData)
    .flatMap((menu) => buildNode(menu))
    .filter(Boolean);
}
